import script from "./TencentCloudDDns.vue?vue&type=script&setup=true&lang=js"
export * from "./TencentCloudDDns.vue?vue&type=script&setup=true&lang=js"

import "./TencentCloudDDns.vue?vue&type=style&index=0&id=84d9d214&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84d9d214"]])

export default __exports__